/**
 * common/utils.js — tiny shared helpers used across the API layer.
 */

/** Build a query string from an object, skipping null/undefined/"" values. */
export function qs(params) {
  if (!params) return "";
  const parts = [];
  for (const k in params) {
    const v = params[k];
    if (v === null || v === undefined || v === "") continue;
    parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
  }
  return parts.length ? "?" + parts.join("&") : "";
}

/** Join API base + path + query into a full URL. */
export function buildUrl(base, path, query) {
  const b = (base || "").replace(/\/+$/, "");
  const p = path.startsWith("/") ? path : "/" + path;
  return b + p + qs(query);
}

/** Promise-based delay. */
export function sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }

/** Read a "a.b.c" dotted path off an object (used by mock sorting). */
export function getPath(obj, path) {
  return path.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);
}

/** Encode/decode an opaque cursor (offset-based here; swap for a real cursor server-side). */
export const cursor = {
  encode(offset) { return offset > 0 ? btoa("o:" + offset) : null; },
  decode(c) { try { return c ? parseInt(atob(c).split(":")[1], 10) || 0 : 0; } catch (e) { return 0; } },
};

/** Stable deterministic PRNG (mirrors data.jsx) — used by the mock to fabricate variations. */
export function mulberry32(a) {
  return function () {
    a |= 0; a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
